import React from "react";
import { Tooltip } from "reactstrap";
import uuid from 'uuid/v1'

export default class DeleteButton extends React.Component {
  state = {
    showToolTip: false,
    confirm: false,
    uniqueId: uuid()
  };
  confirmDelete = (e) => {
    if(!this.props.handleDelete) return
    e.preventDefault();

    const { showToolTip } = this.state

    if (showToolTip) {
      this.setState({ confirm: true })
      this.props.handleDelete(this.props.item)
      this.setState({showToolTip: false, confirm: false})
    } else {
      this.setState({ showToolTip: true })
    }
  }
  handleAwayClick = (e) => {
      this.state.showToolTip ? 
      this.setState({showToolTip: false}) : 
      false
  }
  render() {
      const { showToolTip, uniqueId } = this.state
      const { index } = this.props
    return (
      <React.Fragment>
        <button
          id={`delete-btn-${uniqueId}`}
          className="delete-btn"
          onClick={this.confirmDelete}
          onBlur={this.handleAwayClick}>
          <i className={ !showToolTip ? 'delete-button-icon' : 'delete-clicked-icon'} />
        </button>

        
        <Tooltip isOpen={showToolTip} placement={'top'} target={`delete-btn-${uniqueId}`} style={{backgroundColor: '#4C4C4C'}}>
          Click to confirm deletion
        </Tooltip>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorUIComponents/DeleteButton.js